import React from 'react'
// @ts-ignore no types
import { connect } from 'react-redux'
// @ts-ignore no types
import type { primitives } from '@adc/blueprint'
import { enums } from '@adc/sdk'
import { useListingContext } from 'common/context/listing'
import SectionPanel from '../../components/sectionPanel'
import RegistrationBanner from '../../components/registrationBanner'

interface MessageBannerProps {
  user: primitives.AuctionUser
  pageBannerRef?: any
}

const MessageBanner = ({ user, pageBannerRef }: MessageBannerProps) => {
  const { listing } = useListingContext()
  const authenticateUser = user.logged_in ? user : null
  return (
    <SectionPanel elmId='messages' compact style={{ padding: 0 }}>
      <div className='u-pt-2 u-pb-2'>
        <div ref={pageBannerRef} />
        <RegistrationBanner
          isUserAuthenticated={user.logged_in}
          isUserConfirmed={
            authenticateUser?.status === enums.UserStatus.Confirmed
          }
          isUserRegisteredForAuction={
            listing.is_current_user_registered_for_online_auction
          }
          email={authenticateUser?.email}
        />
      </div>
    </SectionPanel>
  )
}
const mapStateToProps = (store: any) => ({
  user: store.user,
})

export default connect(mapStateToProps, null)(MessageBanner)
